import styled from 'styled-components'
import { FaBars } from 'react-icons/fa'

// O painel do Menu e uma superficie ESCURA, igual ao card e ao Header —
// DESIGN.md: fundo `surface`, texto `surfaceText`, divisor `surfaceAlt`.
// O `&&` dobra a classe gerada para passar a especificidade das regras
// `.dropdown-menu` / `.dropdown-item` do Bootstrap, que por padrao pintam
// fundo claro e texto escuro e venceriam no empate.

export const Container = styled.div`
    
`;

export const ButtonMenu = styled.button`
  && {
    background-color: transparent;
    border: none;
  }

  &&:focus {
    box-shadow: none;
  }
`;

// Painel encostado na borda esquerda da tela e na base do Header.
// O `!important` e necessario: o Popper (Bootstrap) escreve `position`,
// `inset`, `transform` e `margin` como estilo INLINE no elemento, e inline
// vence qualquer classe — nem o `&&` alcanca. 70px = altura do Header
// (ver components/Header/styles.js).
export const ListMenu = styled.ul`
  && {
    position: fixed !important;
    top: 70px !important;
    left: 0 !important;
    right: auto !important;
    bottom: 0 !important;
    transform: none !important;
    margin: 0 !important;

    width: 60%;
    height: auto;
    padding: 0;
    overflow-y: auto;

    background-color: ${({ theme }) => theme.colors.surface};
    border: none;
    border-right: 1px solid ${({ theme }) => theme.colors.borderSubtle};
    border-radius: 0;
  }

  @media (min-width: 768px) {
    && {
      width: 320px;
    }
  }
`;

export const ItemMenu = styled.li`
  && {
    height: 60px;
    padding: 0;
    background-color: transparent;
    border-bottom: 1px solid ${({ theme }) => theme.colors.surfaceAlt};
  }

  &&:hover {
    background-color: transparent;
  }

  &&:last-child {
    border-bottom: none;
  }
`

export const ItemLinkMenu = styled.a`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 16px;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.surfaceText};
    background-color: transparent;
    transition: color 0.2s, background-color 0.2s;
  }

  &&:hover,
  &&:focus {
    color: ${({ theme }) => theme.colors.accentOnSurface};
    background-color: ${({ theme }) => theme.colors.surfaceAlt};
  }
`

export const Icon = styled(FaBars).attrs(({ theme }) => ({
  color: theme.colors.accentOnSurface,
  size: 30
}))``;
